import {Perf10t} from './Perf10t';

export const measure: Perf10t['measure'] = (params) => {
    if (!window.perf10t) {
        return;
    }

    return window.perf10t.measure(params);
};
